import { createReducer, createActions } from 'reduxsauce'
import Immutable from 'seamless-immutable'
//import { exact } from 'prop-types';

/* ------------- Types and Action Creators ------------- */
const { Types, Creators } = createActions({
    searchClients: ['searchCriteria'],
    resetClients: null,
    getClient: ['id'],
    setSelectedClient: ['data'],
    setClients: ['data'],
    setPurchasedProducts: ['data'],
    setSelectedProduct: ['id'],
    getAccountHistory: ['data'],
    setAccountHistory: ['data'],
    getDiyReturns: ['accountid'],
    createSearchLog: ['data'],
    getSecurityInfo: ['data'],
    setSecurityInfo: ['data'],
    searchReturns: ['id', 'taxYear', 'isVmid'],
    setReturns: ['data'],
    setSearchCriteria: ['data'],
    searchAssociatedReturn: ['id', 'taxYear'],
    setAssociatedReturn: ['data'],
    getParty: ['partyId'],
    setParty: ['data']
})

export const ClientTypes = Types
export default Creators

/* ------------- Initial State ------------- */
export const INITIAL_STATE = Immutable({
    searchCriteria: '',
    searchCriteriaType: '',
    resultsCount: null,
    clients: [],
    fuzzyClients: [],
    loadingClient: false,
    loadingClients: false,
    selectedClient: {
        purchasedProducts: [],
        selectedProduct: null
    },
    selectedClientId: null,
    loadingAccountHistory: false,
    clientAccountHistory: {},
    loadingSecurityInfo: false,
    clientSecurityInfo: {},
    searchingReturns: false,
    returns: [],
    searchingAssociatedReturn: false,
    associatedReturnId: null,
    selectedParty: {}
});

/* ------------- Reducers ------------- */
export const clientSearchClients = (state) => {
    return state.merge({ clients: [], selectedClient: {}, loadingClients: true });
}

export const clientResetClients = (state) => INITIAL_STATE;

export const clientSetSearchCriteria = (state, { data }) => {
    const returnResults = data;
    return state.merge({
        searchCriteria: returnResults,
        loadingClients: true
    });
};

export const clientLoadingClient = (state) => {
    return state.merge({ loadingClient: true, selectedClient: {} });
};

export const clientSetSelectedClient = (state, { data }) => {
    const newClient = {
        ...state.selectedClient,
        ...data
    }
    return state.merge({ selectedClient: newClient, loadingClient: false });
};

export const clientSetClients = (state, { data }) => {
    const clientResults = data;
    if (clientResults.clients.length === 1) {
        return state.merge({
            searchCriteria: clientResults.searchCriteria,
            searchCriteriaType: clientResults.searchCriteriaType,
            resultsCount: clientResults.resultsCount,
            clients: clientResults.clients,
            fuzzyClients: clientResults.fuzzyMatches,
            selectedClientId: clientResults.clients[0].id,
            loadingClients: false,
        })
    }
    else {
        return state.merge({
            searchCriteria: clientResults.searchCriteria,
            searchCriteriaType: clientResults.searchCriteriaType,
            resultsCount: clientResults.resultsCount,
            clients: clientResults.clients,
            fuzzyClients: clientResults.fuzzyMatches,
            loadingClients: false,
        })
    }
};

export const clientSetPurchasedProducts = (state, { data }) => {
    var newClient = {
        ...state.selectedClient,
        purchasedProducts: data
    };

    return state.merge({ selectedClient: newClient });
};

export const clientResetPurchasedProducts = (state) => {
    var newClient = {
        ...state.selectedClient,
        purchasedProducts: null
    };
    return state.merge({ selectedClient: newClient });
};

export const clientLoadingAccountHistory = (state) => {
    return state.merge({ loadingAccountHistory: true });
};

export const clientSetAccountHistory = (state, { data }) => {
    return state.merge({ clientAccountHistory: data, loadingAccountHistory: false });
};

export const clientLoadingSecurityInfo = (state) => {
    return state.merge({ loadingSecurityInfo: true });
};

export const clientSetSecurityInfo = (state, { data }) => {
    return state.merge({ clientSecurityInfo: data, loadingSecurityInfo: false });
};

export const clientSearchReturns = (state, { id, taxYear }) => {
    return state.merge({ searchingReturns: true });
}

export const clientSetReturns = (state, { data }) => {
    const returnResults = data;
    return state.merge({
        searchCriteria: returnResults.searchcriteria,
        searchCriteriaType: returnResults.searchcriteriatype,
        returns: returnResults.returns,
        associatedReturnId: returnResults.associatedreturnid,
        searchingReturns: false
    });
};

export const clientSearchAssociatedReturn = (state, { id, taxYear }) => {
    return state.merge({ searchingAssociatedReturn: true });
}

export const clientSetAssociatedReturn = (state, { data }) => {
    return state.merge({ associatedReturnId: data.associatedreturnid, searchingAssociatedReturn: false });
};

export const clientGetParty = (state, { partyId }) => {
    return state.merge({ loadingClient: true });
};

export const clientSetParty = (state, { data }) => {
    return state.merge({ selectedParty: data, loadingClient: false });
};


/* ------------- Hookup Reducers To Types ------------- */
export const reducer = createReducer(INITIAL_STATE, {
    [Types.SEARCH_CLIENTS]: clientSearchClients,
    [Types.RESET_CLIENTS]: clientResetClients,
    [Types.GET_CLIENT]: clientLoadingClient,
    [Types.SET_SELECTED_CLIENT]: clientSetSelectedClient,
    [Types.SET_CLIENTS]: clientSetClients,
    [Types.SET_PURCHASED_PRODUCTS]: clientSetPurchasedProducts,
    [Types.GET_DIY_RETURNS]: clientResetPurchasedProducts,
    [Types.GET_ACCOUNT_HISTORY]: clientLoadingAccountHistory,
    [Types.SET_ACCOUNT_HISTORY]: clientSetAccountHistory,
    [Types.GET_SECURITY_INFO]: clientLoadingSecurityInfo,
    [Types.SET_SECURITY_INFO]: clientSetSecurityInfo,
    [Types.SEARCH_RETURNS]: clientSearchReturns,
    [Types.SET_RETURNS]: clientSetReturns,
    [Types.SET_SEARCH_CRITERIA]: clientSetSearchCriteria,
    [Types.SEARCH_ASSOCIATED_RETURN]: clientSearchAssociatedReturn,
    [Types.SET_ASSOCIATED_RETURN]: clientSetAssociatedReturn,
    [Types.GET_PARTY]: clientGetParty,
    [Types.SET_PARTY]: clientSetParty
});